export default (palette) => ({
  root: {
    backgroundColor: palette.backGroundItem?.tabelaHeaderFooter,
    borderTop: `1px solid ${palette.divider}`,

    // Bordas inferiores arredondadas para fechar o contêiner pill
    borderBottomLeftRadius: '12px',
    borderBottomRightRadius: '12px',
    // Bordas superiores retas (junção com as rows)
    borderTopLeftRadius: '0',
    borderTopRightRadius: '0',

    '& *': {
      color: `${palette.backGroundItem?.tabelaHeaderFooterText} !important`,
    },

    '& button:disabled, & button[disabled], & .Mui-disabled': {
      opacity: '0.38 !important',
    },

    '& .MuiTableRow-root': {
      backgroundColor: 'transparent !important',
    },
    '& .MuiTableCell-root': {
      backgroundColor: 'transparent !important',
      borderBottom: 'none',
    },
  },
})
